import { HttpHeaders, HttpParams } from "@angular/common/http";
import { ResponseContentType } from "@cemex-core/cmx-api-v7";

export class CmxHttpOptions {
  headers?: HttpHeaders;
  observe?: any = "body";
  params?:
    | HttpParams
    | {
        [param: string]: string | string[];
      };
  reportProgress?: boolean;
  responseType?: any = ResponseContentType.JSON;
  withCredentials?: boolean;
}
